import { useState } from "react";
import FileDnd from "../../../../components/FileDnD";
import FormField from "../../../../components/FormFiel/FormFiel";
import { useForm } from "react-hook-form";
import { v4 as uuidv4 } from "uuid";
import { saveNewProperty } from "../../../../application/saveProperty";
import { saveMultipleImages } from "../../../../application/saveImg";
import { BounceLoader } from "react-spinners";

function PropertyCreate() {
  const [loading, setLoading] = useState(false);
  const [files, setFiles] = useState([]);
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();

  const currency = watch("currency");
  const state = watch("state");

  const handleFiles = (files) => {
    if (Array.isArray(files)) {
      setFiles(files);
    } else {
      console.error("handleFiles: El valor recibido no es un array");
    }
  };

  function generateShortId() {
    return uuidv4().split("-")[0];
  }

  const onSubmit = async (formData) => {
    setLoading(true);
    try {
      // Generar un ID único para la propiedad
      const propertyId = generateShortId();
      // Guardar imágenes
      const resultStorage = await saveMultipleImages(files, propertyId);
      const formattedData = {
        id: propertyId,
        name: formData.name,
        type: formData.type,
        state: formData.state,
        country: formData.country,
        address: formData.address,
        characteristics: {
          ambientes: formData.ambientes || "",
          dormitorios: formData.dormitorios || "",
          baños: formData.baños || "",
          patio: formData.patio || "",
          expensas: formData.expensas || "",
          estado: formData.estado || "",
          plantas: formData.plantas || "",
          contrato: formData.contrato || "",
        },
        description: formData.description,
        currency: formData.currency || "",
        price: formData.price || "",
        maps: formData.maps,
        highlights: formData.highlights === "true" ? true : false,
        images: resultStorage,
      };

      // Guardar la nueva propiedad
      await saveNewProperty(formattedData);
      //console.log("Propiedad guardada con éxito:", formattedData);
    } catch (error) {
      console.error("Error al guardar la propiedad:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="">
      {loading ? (
        <div className="fixed inset-0 bg-gray-800 bg-opacity-20 flex items-center justify-center z-50">
          <div className="absolute inset-0 backdrop-blur-sm"></div>
          <div className="flex flex-col justify-center items-center z-10">
            <BounceLoader className="my-2" color="#187795" size={60} />
            <h2 className="text-xl">Guardando Propiedad</h2>
          </div>
        </div>
      ) : (
        <section className="sm:w-8/12 p-6 mx-auto bg-white rounded-md shadow-md dark:bg-gray-700">
          <h1 className="text-xl font-bold text-black capitalize dark:text-white">
            Nueva Propiedad
          </h1>
          <div className="relative mt-4 mb-4">
            <div className="absolute inset-0 flex items-center">
              <div className="w-full border-t border-gray-300"></div>
            </div>
            <div className="relative flex justify-center text-sm">
              <span className="px-2 text-gray-500 bg-white">Imagenes</span>
            </div>
          </div>
          <div className="py-4">
            <FileDnd onFilesChange={handleFiles} />
          </div>

          <form onSubmit={handleSubmit(onSubmit)}>
            {/* Datos */}
            <div className="relative mt-4 mb-4">
              <div className="absolute inset-0 flex items-center">
                <div className="w-full border-t border-gray-300"></div>
              </div>
              <div className="relative flex justify-center text-sm">
                <span className="px-2 text-gray-500 bg-white">Datos</span>
              </div>
            </div>
            <FormField
              label="Nombre"
              id="name"
              name="nombre"
              type="text"
              required={true}
              maxLength={50}
              placeholder="Nombre"
              autoComplete="off"
              errors={errors}
              register={register}
            />
            <div className="grid grid-cols-1 gap-6 mt-4 sm:grid-cols-2">
              <FormField
                label="Tipo"
                id="type"
                required={true}
                name="tipo"
                type="select"
                errors={errors}
                register={register}
                options={[
                  { value: "", label: "Seleccionar tipo" },
                  { value: "Casa", label: "Casa" },
                  { value: "Departamento", label: "Departamento" },
                  { value: "Local", label: "Local" },
                  { value: "Oficina", label: "Oficina" },
                  { value: "Terreno", label: "Terreno" },
                ]}
              />

              <FormField
                label="Estado"
                id="state"
                required={true}
                name="estado"
                type="select"
                errors={errors}
                register={register}
                options={[
                  { value: "", label: "Seleccionar estado" },
                  { value: "Alquiler", label: "Alquiler" },
                  { value: "Alquilado", label: "Alquilado" },
                  { value: "Venta", label: "Venta" },
                  { value: "Vendido", label: "Vendido" },
                ]}
              />
            </div>

            <div className="relative mt-6">
              <div className="absolute inset-0 flex items-center">
                <div className="w-full border-t border-gray-300"></div>
              </div>
              <div className="relative flex justify-center text-sm">
                <span className="px-2 text-gray-500 bg-white">Ubicación</span>
              </div>
            </div>
            <div className="grid grid-cols-1 gap-6 mt-4 sm:grid-cols-2">
              <FormField
                label="Localidad"
                id="country"
                name="localidad"
                required={true}
                type="text"
                maxLength={20}
                placeholder="Localidad"
                autoComplete={"off"}
                errors={errors}
                register={register}
              />

              <FormField
                label="Dirección"
                id="address"
                name="dirección"
                required={true}
                type="text"
                maxLength={45}
                placeholder="Dirección"
                autoComplete={"off"}
                errors={errors}
                register={register}
              />
            </div>
            <div className="relative mt-4 mb-4">
              <div className="absolute inset-0 flex items-center">
                <div className="w-full border-t border-gray-300"></div>
              </div>
              <div className="relative flex justify-center text-sm">
                <span className="px-2 text-gray-500 bg-white">
                  Caracteristicas
                </span>
              </div>
            </div>
            <div className="grid grid-cols-1 gap-6 mt-4 sm:grid-cols-2">
              <FormField
                label="Cantidad de Ambientes"
                id="ambientes"
                name="ambientes"
                required={false}
                type="number"
                maxLength={10}
                placeholder="Ambientes"
                autoComplete={"off"}
                errors={errors}
                register={register}
              />
              <FormField
                label="Cantidad de Dormitorios"
                id="dormitorios"
                name="dormitorios"
                required={false}
                type="number"
                maxLength={10}
                placeholder="Dormitorios"
                autoComplete={"off"}
                errors={errors}
                register={register}
              />
              <FormField
                label="Cantidad de Baños"
                id="baños"
                name="baños"
                required={false}
                type="number"
                maxLength={10}
                placeholder="Baños"
                autoComplete={"off"}
                errors={errors}
                register={register}
              />
              <FormField
                label="¿Tiene patio?"
                id="patio"
                required={false}
                name="patio"
                type="select"
                errors={errors}
                register={register}
                options={[
                  { value: "", label: "Seleccionar patio" },
                  { value: "Si", label: "Si" },
                  { value: "No", label: "No" },
                ]}
              />
              <FormField
                label="¿Tiene expensas?"
                id="expensas"
                required={false}
                name="expensas"
                type="select"
                errors={errors}
                register={register}
                options={[
                  { value: "", label: "Seleccionar expesas" },
                  { value: "Si", label: "Si" },
                  { value: "No", label: "No" },
                ]}
              />
              <FormField
                label="Estado del inmueble"
                id="estado"
                required={false}
                name="estado"
                type="select"
                errors={errors}
                register={register}
                options={[
                  { value: "", label: "Seleccionar estado" },
                  { value: "Nuevo", label: "Nuevo" },
                  { value: "Usado", label: "Usado" },
                  { value: "Bueno", label: "Bueno" },
                  { value: "Muy Bueno", label: "Muy Bueno" },
                  { value: "Exelente", label: "Exelente" },
                ]}
              />
              <FormField
                label="Cantidad de Plantas"
                id="plantas"
                name="plantas"
                required={false}
                type="number"
                maxLength={10}
                placeholder="Plantas"
                autoComplete={"off"}
                errors={errors}
                register={register}
              />

              {state !== "Venta" && state !== "Vendido" && (
                <FormField
                  label="Contrato"
                  id="contrato"
                  name="contrato"
                  required={false}
                  type="text"
                  maxLength={50}
                  placeholder="Contrato"
                  autoComplete={"off"}
                  errors={errors}
                  register={register}
                />
              )}
            </div>
            <div className="relative mt-4 mb-4">
              <div className="absolute inset-0 flex items-center">
                <div className="w-full border-t border-gray-300"></div>
              </div>
              <div className="relative flex justify-center text-sm">
                <span className="px-2 text-gray-500 bg-white">Descripción</span>
              </div>
            </div>

            <FormField
              label="Descripción"
              id="description"
              name="descripcion"
              required={true}
              type="textarea"
              rows={8}
              placeholder="Description aquí..."
              errors={errors}
              register={register}
            />

            <div className="relative mt-4 mb-4">
              <div className="absolute inset-0 flex items-center">
                <div className="w-full border-t border-gray-300"></div>
              </div>
              <div className="relative flex justify-center text-sm">
                <span className="px-2 text-gray-500 bg-white">Ubicación</span>
              </div>
            </div>

            <FormField
              label="URL de Google Maps"
              id="maps"
              name="mapa"
              required={true}
              type="text"
              placeholder="URL de Google Maps"
              autoComplete={"off"}
              errors={errors}
              register={register}
            />

            <div className="relative mt-4 mb-4">
              <div className="absolute inset-0 flex items-center">
                <div className="w-full border-t border-gray-300"></div>
              </div>
              <div className="relative flex justify-center text-sm">
                <span className="px-2 text-gray-500 bg-white">
                  Destacar Propiedad
                </span>
              </div>
            </div>

            <FormField
              label="Destacar Propiedad"
              id="highlights"
              required={false}
              name="destacar propiedad"
              type="select"
              errors={errors}
              register={register}
              options={[
                { value: "", label: "Destacar propiedad" },
                { value: true, label: "Si" },
                { value: false, label: "No" },
              ]}
            />
            <p className="text-xs text-slate-500 mt-2">
              Este campo te permite dar mayor visibilidad a una propiedad en la
              lista de resultados. Si seleccionas "Sí", la propiedad aparecerá
              arriba del todo en la lista, resaltándola sobre las demás.
            </p>

            {state !== "Alquilado" && state !== "Vendido" && (
              <>
                <div className="relative mt-6">
                  <div className="absolute inset-0 flex items-center">
                    <div className="w-full border-t border-gray-300"></div>
                  </div>
                  <div className="relative flex justify-center text-sm">
                    <span className="px-2 text-gray-500 bg-white">Precio</span>
                  </div>
                </div>

                <div className="grid grid-cols-1 gap-6 mt-4 sm:grid-cols-2">
                  <FormField
                    label="Moneda"
                    id="currency"
                    required={true}
                    name="moneda"
                    type="select"
                    errors={errors}
                    register={register}
                    options={[
                      { value: "", label: "Seleccionar moneda" },
                      { value: "$", label: "$" },
                      { value: "USD", label: "USD" },
                      { value: "Consultar", label: "Consultar" },
                    ]}
                  />

                  {currency !== "Consultar" && (
                    <FormField
                      label="Precio"
                      id="price"
                      name="precio"
                      required={true}
                      type="number"
                      maxLength={10}
                      placeholder="Precio"
                      autoComplete={"off"}
                      errors={errors}
                      register={register}
                    />
                  )}
                </div>
              </>
            )}

            <div className="flex justify-end mt-6">
              <button
                type="submit"
                className="px-6 py-2 leading-5 text-white transition-colors duration-200 transform bg-primary hover:opacity-80 rounded-md"
              >
                Guardar
              </button>
            </div>
          </form>
        </section>
      )}
    </div>
  );
}

export default PropertyCreate;
